import './CoralFooter.scss'

import { getCookieConsent } from '@websrc/App/Helpers/cookieUtil'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapCookiePolicy } from '@websrc/DataMappers/mapCookiePolicy'
import { mapCoralWebFooter } from '@websrc/DataMappers/mapCoralFooter'
import React, { FC, useState } from 'react'

import { CookieSettings } from '../../CookieConsent/CookieConsent'
import { CoralLogo } from '../../CoralLogo/CoralLogo'
import { Markdown } from '../../Markdown/Markdown'
import { Flower } from './illustrations/Flower'
import { Wave } from './illustrations/Wave'

export interface CoralFooterProps {
  cookiePolicy: ReturnType<typeof mapCookiePolicy>
  copyright: ReturnType<typeof mapCoralWebFooter>['copyright']
  policy: ReturnType<typeof mapCoralWebFooter>['policy']
}

export const CoralFooter: FC<CoralFooterProps> = ({ cookiePolicy, copyright, policy }) => {
  const [showCookieSettings, setShowCookieSettings] = useState(false)
  const t = useStaticText()

  const currentConsent = getCookieConsent()

  const cookies = cookiePolicy.preferences.map((pref) => ({
    ...pref,
    selected:
      pref.category === 'necessary' ||
      Boolean(currentConsent?.preferences?.find((cat) => cat.key === pref.category && cat.value)),
  }))

  return (
    <>
      <div className={'illustration'}>
        <div className={'illustration__flower-wrapper'}>
          <Flower className={'illustration__flower'} />
        </div>
        <Wave className={'illustration__wave'} />
      </div>
      <footer className={'coral-footer-container'} id={'main-footer'}>
        <div className={'coral-footer'}>
          <CoralLogo className={'coral-footer__logo'} isDarkBackground={true} />
          <div className={'coral-footer__policy'}>
            {policy.map((link, key) => (
              <a className={'coral-footer__link'} href={link.url} key={key}>
                <span>{link.title}</span>
              </a>
            ))}
            <button className={'coral-footer__button'} onClick={() => setShowCookieSettings(true)}>
              {t.cookies.cookie_settings}
            </button>
          </div>
          <Markdown className={'coral-footer__copyright'} markdown={copyright} skipWidth={true} />
          {showCookieSettings && (
            <CookieSettings
              acceptSettingsCallback={() => setShowCookieSettings(false)}
              cancelSettingsCallback={() => setShowCookieSettings(false)}
              current={cookies}
            />
          )}
        </div>
      </footer>
    </>
  )
}
